exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vgv-display iframe {\n  height: 40px;\n  width: 100%;\n}\n\n", ""]);

// exports
